import cn from "classnames";
import styles from "./HashSelector.module.scss";
import Algorithm from "../Algorithm/Algorithm";
import Icon from "../Icon/Icon";
import { useHashSelectorControl } from "./useHashSelectorControl";
import { IHashSelectorProps } from "./HashSelector.props";
import { useEffect } from "react";
import { ALGOS_E } from "@constants/Algos";
import { Select } from "../Select/Select";

export default function HashSelector({
  clear = true,
  ...props
}: IHashSelectorProps) {
  const control = useHashSelectorControl(props);

  const { hashOptions, name, id, refresh, initial } = props;
  const filteredHash = () =>
    hashOptions.filter((item) => item !== control.value);

  useEffect(() => {
    if (!refresh) return;
    control.onSelect(undefined);
  }, [refresh]);

  const { onChangeValue, ...divProps } = props;

  return <Select
    showSearch
    filterOption={(input, option) => {
      return (option?.value as string ?? '').toLowerCase().includes(input.toLowerCase());
    }}
    size="small"
    outlined={props.outlined}
    disabled={props.disabled}
    label={<span className={styles.label}>{name}</span>}
    id={id}
    onChange={control.onSelect}
    value={control.value}
    options={hashOptions.map(hash => ({
      label: <Algorithm
        iconSize={16}
        algo={hash}
        className={cn(styles.selector, styles.item, styles.algo)}
        hashName={hash}
      />,
      value: hash,
    }))}
  />
}
